import {AfterViewInit, Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {environment} from '../../../../environments/environment';
import {Toast} from 'primeng/toast';
import {ColorService} from '../../services/color/color.service';
import {PleaseWaitService} from '../../services/please-wait/please-wait.service';
import {AuthService} from '../../../auth/services/auth/auth.service';
import {TenantService} from '../../../auth/services/tenant/tenant.service';
import {UserService} from '../../../user/services/user/user.service';
import {AppService} from '../../services/app/app.service';
import {TabbingService} from '../../../tabbing/services/tabbing.service';
import {ElectronService} from 'ngx-electron';
import {AppStateService, AppWindowState} from '../../services/appState/app-state.service';
import {HarService} from '../../../logging/services/har.service';
import {UpdaterService} from '../../services/updater/updater.service';
import {PrimeNGConfig} from 'primeng/api';
import {LoggerService} from '../../../logging/services/logger.service';
import {NavigationService} from '../../services/navigation.service';
import {SignalRService} from '../../services/signalr/signal-r.service';
import {PlatformAwareComponent} from '../../../_widget-library/platform-aware/platform-aware.component';
import {LoggerConsoleService} from "../../../logging/services/logger-console.service";
import {LoggerDeviceService} from "../../../logging/services/logger-device.service";
import {PlatformService} from "../../services/native/platform.service";
import {NativeService} from "../../services/native/native.service";

@Component({
  selector: 'app-main-window',
  templateUrl: './main-window.component.html',
  styleUrls: ['./main-window.component.scss']
})
export class MainWindowComponent extends PlatformAwareComponent implements OnInit, AfterViewInit {
  title = 'frontend';
  env = environment;

  // extendedChange: EventEmitter<boolean>;
  public isSideNavExtended = true;

  AppWindowState = AppWindowState;

  @ViewChild('cedeToast') cedeToast: Toast;
  initialized = false;

  constructor(public colorService: ColorService,
              public pleaseWaitService: PleaseWaitService,
              public authService: AuthService,
              public tenantService: TenantService,
              private platformService: PlatformService,
              private nativeService: NativeService,
              private userService: UserService,
              public appService: AppService,
              public tabbingService: TabbingService,
              public electronService: ElectronService,
              public appStateService: AppStateService,
              public harService: HarService,
              public updaterService: UpdaterService,
              public primengConfig: PrimeNGConfig,
              public loggerService: LoggerService,
              private loggerConsoleService: LoggerConsoleService,
              private loggerDeviceService: LoggerDeviceService,
              private navigationService: NavigationService,
              public signalRService: SignalRService,
              private elementRef: ElementRef) {
    super(elementRef, electronService);
    this.colorService = colorService;
    this.authService = authService;
    this.electronService = electronService;
    primengConfig.ripple = true;
  }

  async ngOnInit() {
    this.isSideNavExtended = localStorage.getItem('state.extended') === 'true';
    localStorage.setItem('state.extended', this.isSideNavExtended.toString());

    if (this.electronService.isElectronApp) {
      document.onkeyup = (e) => {
        if (e.ctrlKey && e.shiftKey && e.which === 73) {
          this.electronService.ipcRenderer.send('open-devtools');
        }
      };
    }
    // this.extendedChange.subscribe( x => )
    await this.connectToSignalRAppointments();
    await this.redirectToRegister();

    if (this.platformService.isElectronApp) {
      const promise = await this.nativeService.getVersion();
      const {version} = promise;
      const splits = version.split('.');
      const major = Number(splits[0]);
      const minor = Number(splits[1]);
      if (major <= 0 && minor <= 8) {
        setInterval(() => {
          this.appStateService.appWindowState = AppWindowState.ForceUpdate;
        }, 100);
      }
    }
  }

  private async connectToSignalRAppointments() {
    await this.appStateService.appWindowStateChange.subscribe((state) => {
      if (state.previousValue === AppWindowState.Loading && state.currentValue === AppWindowState.Main) {
        if (this.tenantService.authenticated) {
          this.signalRService.connect();
        }
      }
    });
  }

  commonClose(message: any, subtractCount: boolean = true) {
    let index = 0;
    for (const msg of this.cedeToast.messages) {
      if (message === msg) {
        break;
      }
      index++;
    }
    const event = {index, message};
    this.cedeToast.onMessageClose(event);
    if (subtractCount) {
      this.appService.actionMessagesCount--;
    }
  }

  getTimeLeft(message: any) {
    if (message.data && message.data.timerObj && message.data.timerObj.date && message.data.timerObj.date < new Date()) {
      this.commonClose(message, false);
    }

    // return the same result, without using momentjs
    const date = new Date(message.data.timerObj.date);
    const now = new Date();
    const diff = date.getTime() - now.getTime();
    const seconds = Math.floor(diff / 1000);
    const minutes = Math.floor(seconds / 60);
    const hours = Math.floor(minutes / 60);
    const days = Math.floor(hours / 24);

    if (days > 0) {
      return days + ' days';
    } else if (hours > 0) {
      return hours + ' hours';
    } else if (minutes > 0) {
      return minutes + ' minutes';
    }
    return seconds + ' seconds';
  }

  async redirectToRegister() {
    if (this.electronService.isElectronApp) {
      await this.electronService.ipcRenderer.send('generate-init-file', {check: true});
      await this.electronService.ipcRenderer.on('navigate-to-register', (event, message) => {
        if (message === true) {
          if (!this.authService.isLoggedIn) {
            this.appStateService.appWindowState = AppWindowState.Register;
          } else {
            this.appStateService.appWindowState = AppWindowState.Tenant;
          }
        }
      });
    }
  }
}
